<div class="footer row">
  <a class="col-md-2 offset-md-4" routerLink="donnéespersonnelles" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><span style="font-size: smaller;">Données personnelles</span></a>
  <a class="col-md-2" routerLink="mentions-legales" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><span style="font-size: smaller;">Mentions légales</span></a>
</div>
